import React from 'react';
import classnames from 'classnames';
import FontAwesome from 'react-fontawesome';

import styles from './select.less';

const CogArrowRenderer = ({ className }) => {
  const _className = classnames(styles['cog-arrow-renderer'], className);

  return <FontAwesome className={_className} name="cog" />;
};

CogArrowRenderer.propTypes = {
  ...FontAwesome.propTypes,
};

CogArrowRenderer.defaultProps = {
  ...FontAwesome.defaultProps,
};

export default CogArrowRenderer;
export { CogArrowRenderer };
